import common from '../contexts/es/common.json';
import language from '../contexts/es/language.json';
import loginScreen from '../contexts/es/loginScreen.json';
import offlineScreen from '../contexts/es/offlineScreen.json';
import signatureScreen from '../contexts/es/signatureScreen.json';
import mainLayout from '../contexts/es/mainLayout.json';
import dashboard from '../contexts/es/dashboard.json';
import novaAI from '../contexts/es/novaAI.json';
import shopHomePage from '../contexts/es/shopHomePage.json';
import pinAuthentication from '../contexts/es/pinAuthentication.json';
import header from '../contexts/es/header.json';
import repairDetails from '../contexts/es/repairDetails.json';
import vinScanner from '../contexts/es/vinScanner.json';
import appVersion from '../contexts/es/appVersion.json';
import createFlow from '../contexts/es/createFlow.json';

export default {
  common,
  language,
  loginScreen,
  offlineScreen,
  signatureScreen,
  mainLayout,
  dashboard,
  novaAI,
  shopHomePage,
  pinAuthentication,
  header,
  repairDetails,
  vinScanner,
  appVersion,
  createFlow,
};
